import { render } from "./App.vue?vue&type=template&id=3f05ca24&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=3f05ca24&lang=scss"
import "./styles/scss/styles.scss?vue&type=style&index=1&lang=scss"
import "./styles/scss/media.scss?vue&type=style&index=2&lang=scss"
import "./styles/css/normalize.css?vue&type=style&index=3&lang=css"
import "./styles/css/reset.css?vue&type=style&index=4&lang=css"
import "./App.vue?vue&type=style&index=5&id=3f05ca24&lang=scss"

import exportComponent from "D:\\Onix_View_Internship\\website-redesign-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__